export const REQUEST_EXPERIMENT = 'REQUEST_EXPERIMENT';
export const RECEIVE_EXPERIMENT = 'RECEIVE_EXPERIMENT';
export const REQUEST_EXPERIMENTS = 'REQUEST_EXPERIMENTS';
export const RECEIVE_EXPERIMENTS = 'RECEIVE_EXPERIMENTS';
export const REQUEST_ARCHIVED_EXPERIMENTS = 'REQUEST_ARCHIVED_EXPERIMENTS';
export const RECEIVE_ARCHIVED_EXPERIMENTS = 'RECEIVE_ARCHIVED_EXPERIMENTS';
export const CLEAR_SELECTABLE_SAVE_CONTEXT = 'CLEAR_SELECTABLE_SAVE_CONTEXT';
export const REQUEST_SAVE_EXPERIMENT = 'REQUEST_SAVE_EXPERIMENT';
export const RECEIVE_SAVE_EXPERIMENT = 'RECEIVE_SAVE_EXPERIMENT';
export const REQUEST_SAVE_SELECTABLE = 'REQUEST_SAVE_SELECTABLE';
export const RECEIVE_SAVE_SELECTABLE = 'RECEIVE_SAVE_SELECTABLE';
export const UPDATE_EXPERIMENT_FILTER = 'UPDATE_EXPERIMENT_FILTER';
export const REQUEST_EXPERIMENT_PERFORMANCE = 'REQUEST_EXPERIMENT_PERFORMANCE';
export const RECEIVE_EXPERIMENT_PERFORMANCE = 'RECEIVE_EXPERIMENT_PERFORMANCE';
export const REQUEST_EXPERIMENT_JOBS = 'REQUEST_EXPERIMENT_JOBS';
export const RECEIVE_EXPERIMENT_JOBS = 'RECEIVE_EXPERIMENT_JOBS';
export const MODIFY_EXPERIMENT_ANALYTICS_FILTER =
  'MODIFY_EXPERIMENT_ANALYTICS_FILTER';
